import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { LayoutSplashScreen } from "../../../../_themeBase/layout";
import * as auth from "../_redux/authRedux";
import { logout } from "../_redux/authCrud";
import { clearAllStorage } from "../../../../_themeBase/_helpers";


class Logout extends Component {
  componentDidMount() {
    logout()
      .then((res) => {
        clearAllStorage();
        if (res && res.data && res.data.statusCode === "URLRedirection" && res.data.message) {
          window.location.replace(res.data.message);
        } else {
          this.props.logout();
          window.location.href = "/#/auth/login";
          window.location.reload();
        }
      })
      .catch((err) => {
        clearAllStorage();
        window.location.href = "/#/auth/login";
        window.location.reload();
      });
  }

  render() {
    const { hasAuthToken } = this.props;
    return hasAuthToken ? <LayoutSplashScreen /> : <Redirect to="/auth/login" />;
  }
}

export default connect(
  ({ auth }) => ({ hasAuthToken: Boolean(auth.authToken), user: auth.user }),
  auth.actions
)(Logout);
